<div class="d-none d-xl-block">
  <div v-if="loading" class="portal-sidebar-card-compact mt-2">
    <div class="portal-sidebar-body text-center py-4 px-3">
      <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2 mb-0 text-muted text-xxs">Loading Positions...</p>
    </div>
  </div>

  <div v-else-if="positions.length" class="portal-sidebar-card-compact portal-positions-card mt-2">
    <div class="portal-sidebar-header d-flex align-items-center justify-content-between">
      <h6 class="mb-0">Portal Positions</h6>
      <button
        class="portal-sidebar-avatar border-0 ms-auto"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#create_position"
        aria-label="Create Position"
        v-if="user_details?.user_role === 'admin' || portal_admin || user_details?.user_role === 'organization admin'"
      >
        <i class="bi bi-plus-lg"></i>
      </button>
    </div>

    <div class="portal-sidebar-body portal-positions-body">
      <div class="portal-sidebar-list d-flex flex-column">
        <div v-for="position in visiblePositions" :key="position.position_id" class="portal-sidebar-item">
          <span class="portal-sidebar-avatar">
            <i class="bx bxs-user-pin"></i>
          </span>
          <span class="portal-sidebar-name">{{ position.position_name }}</span>

          <div class="dropdown ms-auto" v-if="user_details?.user_role === 'admin' || portal_admin || user_details?.user_role === 'organization admin'">
            <i class="bx bx-dots-vertical-rounded cursor-pointer" data-bs-toggle="dropdown"></i>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <a
                  class="dropdown-item text-xxs"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#edit_position_modal"
                  @click.prevent="open_edit_modal(position)"
                >Edit</a>
              </li>
              <li>
                <a
                  class="dropdown-item text-xxs"
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#assign_position_modal"
                  @click.prevent="open_assign_modal(position)"
                >Assign</a>
              </li>
              <li>
                <a
                  class="dropdown-item text-xxs text-danger"
                  href="#"
                  @click.prevent="delete_position(position.position_id, portal_id)"
                >Delete</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <button
        v-if="positions.length > visibleCount"
        type="button"
        class="portal-sidebar-see-all btn btn-link btn-sm w-100 text-decoration-none"
        @click="toggleShowMore"
      >
        {{ showAll ? 'See Less' : 'See All' }}
      </button>
    </div>
  </div>

  <div v-else class="portal-sidebar-card-compact mt-2">
    <div class="portal-sidebar-body text-center py-4 px-3">
      <button
        class="portal-sidebar-avatar border-0 mb-3"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#create_position"
        aria-label="Create Position"
      >
        <i class="bi bi-plus-lg"></i>
      </button>
      <h6 class="fw-bold mb-1">No positions yet</h6>
      <p class="text-muted text-xxs mb-0">Create your first position to get started.</p>
    </div>
  </div>
</div>

<!-- Create Position Modal -->
<teleport to="body">
  <div class="modal fade" id="create_position" tabindex="-1" aria-labelledby="create_position_modal_label"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="exampleModalLabel">Create a Position</p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
        </button>
        </div>
        <form @submit.prevent="create_role">
          <div class="modal-body">
            <div class="mb-3">
              <label for="position_name" class="form-label text-xxs fw-500">
                Position Name <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control rounded text-xxs" id="position_name"
                placeholder="Enter position name" v-model="position_name">
              <p v-if="errors && errors.position_name" class="text-danger text-xxs">
                {{ errors.position_name }}
              </p>

              <!-- <p v-if="errors.position_name" class="text-danger text-xxs">{{ errors.position_name }}</p> -->
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Create</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<!-- Edit Modal (always in DOM; Bootstrap can find it) -->
<teleport to="body">
  <div
    class="modal fade"
    id="edit_position_modal"
    tabindex="-1"
    aria-labelledby="edit_position_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
      <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="edit_position_label">Edit Position</p>
          <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close">
          </button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="save_position_name">
            <div class="mb-3">
              <label class="form-label fw-semibold text-xxs">
                Position Name <span class="text-danger">*</span>
              </label>
              <input
                v-model="editingPosition.newName"
                type="text"
                class="form-control rounded text-xxs"
                placeholder="Enter position name"
              />
              <p v-if="errors && errors.position_name" class="text-danger text-xxs mb-0">
                {{ errors.position_name }}
              </p>
            </div>

            <div class="text-end">
              <button type="submit" class="btn btn-primary btn-sm text-xxs px-4 rounded" data-bs-dismiss="modal">
                Save
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</teleport>

<!-- Assign Position Modal -->
<teleport to="body">
  <div class="modal fade" id="assign_position_modal" tabindex="-1" aria-labelledby="assign_position_modal_label"
    aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="assign_position_modal_label">
            Assign {{ selected_position?.position_name }} to User
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>

        <div class="modal-body table-responsive">
          <table v-if="portalUsers.length" id="assignPositionTable" class="table table-striped text-xxs">
            <thead class="btn-primary text-white">
              <tr>
                <th scope="col">User</th>
                <th scope="col" class="text-end">Action</th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in portalUsers" :key="user.id">
                <td>{{ user.full_name || user.username }}</td>
                <td class="text-end">
                  <button
                    v-if="!isUserAssignedToPosition(user, selected_position.position_id)"
                    class="btn btn-sm btn-primary rounded text-xxs"
                    @click="assign_portal_position(user.user.id, selected_position.position_id, portal_id)"
                  >
                  Assign
                  </button>
                  <button
                    v-else
                    class="btn btn-sm btn-danger rounded text-xxs"
                    @click="unassign_portal_position(user.user.id, selected_position.position_id, portal_id)"
                  >
                  Unassign
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <p v-else class="text-center text-muted text-xxs mb-0 py-2">
            No users found for this portal.
          </p>
        </div>
      </div>
    </div>
  </div>
</teleport>


<!-- Mobile Offcanvas -->
<div
  class="offcanvas offcanvas-end d-xl-none mt-2"
  tabindex="-1"
  id="positionsOffcanvas"
  aria-labelledby="positionsOffcanvasLabel"
>


  <div class="offcanvas-body p-3">
    <div class="d-flex justify-content-between align-items-center mt-4">
      <h5 class="offcanvas-title mb-0" id="positionsOffcanvasLabel">Portal Positions</h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>

    <div v-if="loading" class="portal-sidebar-card mt-3">
      <div class="portal-sidebar-body text-center py-4 px-3">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="text-muted text-xxs mt-2 mb-0">Loading Positions...</p>
      </div>
    </div>

    <div v-else-if="positions.length" class="portal-sidebar-card portal-positions-card mt-3">
      <div class="portal-sidebar-header d-flex align-items-center justify-content-between">
        <h6 class="mb-0">Portal Positions</h6>
        <button
          class="portal-sidebar-avatar border-0 ms-auto"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#create_position"
          aria-label="Create Position"
          v-if="user_details?.user_role === 'admin' || portal_admin"
        >
          <i class="bi bi-plus-lg"></i>
        </button>
      </div>

      <div class="portal-sidebar-body portal-positions-body">
        <div class="portal-sidebar-list d-flex flex-column">
          <div v-for="position in visiblePositions" :key="position.position_id" class="portal-sidebar-item">
            <span class="portal-sidebar-avatar">
              <i class="bx bxs-user-pin"></i>
            </span>
            <span class="portal-sidebar-name">{{ position.position_name }}</span>

            <div class="dropdown ms-auto" v-if="user_details?.user_role === 'admin' || portal_admin">
              <i class="bx bx-dots-vertical-rounded cursor-pointer" data-bs-toggle="dropdown"></i>
              <ul class="dropdown-menu dropdown-menu-end">
                <li>
                  <a
                    class="dropdown-item text-xxs"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_position_modal"
                    @click.prevent="open_edit_modal(position)"
                  >Edit</a>
                </li>
                <li>
                  <a
                    class="dropdown-item text-xxs"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#assign_position_modal"
                    @click.prevent="open_assign_modal(position)"
                  >Assign</a>
                </li>
                <li>
                  <a
                    class="dropdown-item text-danger text-xxs"
                    href="#"
                    @click.prevent="delete_position(position.position_id, portal_id)"
                  >Delete</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <button
          v-if="positions.length > visibleCount"
          type="button"
          class="portal-sidebar-see-all btn btn-link btn-sm w-100 text-decoration-none"
          @click="toggleShowMore"
        >
          {{ showAll ? 'See Less' : 'See All' }}
        </button>
      </div>
    </div>

    <div v-else class="portal-sidebar-card mt-3">
      <div class="portal-sidebar-body text-center py-4 px-3">
        <button
          class="portal-sidebar-avatar border-0 mb-3"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#create_position"
          aria-label="Create Position"
          v-if="user_details?.user_role === 'admin' || portal_admin"
        >
          <i class="bi bi-plus-lg"></i>
        </button>
        <h6 class="fw-bold mb-1">No positions yet</h6>
        <p class="text-muted text-xxs mb-0">Create your first position to get started.</p>
      </div>
    </div>
  </div>
</div>
